import React from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import Cards from '../Cards';
import Footer from '../Footer';
import MediaSection from '../MediaSection';
import VideoSection from '../VideoSection';
import { useEffect } from 'react';

function Home() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <HeroSection />
            <Cards />
            <VideoSection />
            <MediaSection />
            <Footer />
        </>
    )
}

export default Home;